<bit-progress
  [size]="size"
  [text]="text"
  [bgColor]="color"
  [showText]="showText"
  [barWidth]="scoreWidth"
></bit-progress>
